// extracted by mini-css-extract-plugin
export default {"form":"createCategory_form__uuOki","formInputBlock":"createCategory_formInputBlock__4f6YJ","formInput":"createCategory_formInput__biRAn"};